<template>
  <div>
    <vs-button
      color="primary"
      type="border"
      icon="calendar_today"
      @click="popupActive=true"
    >
      期間-{{ period }}
    </vs-button>
    <vs-popup
      v-model:active="popupActive"
      class="holamundo"
      title="日付範囲"
    >
      <div class="flex mb-4">
        <div class="w-1/5 bg-grid-color-secondary">
          <div class="btn-group-vertical w-full">
            <vs-button
              v-if="!isPastYearMode"
              @click="todayDate"
            >
              今日
            </vs-button>
            <vs-button
              v-if="!isPastYearMode"
              @click="yesterdayDate"
            >
              昨日
            </vs-button>
            <vs-button
              v-if="!isPastYearMode"
              @click="thisMonthDate"
            >
              今月
            </vs-button>
            <vs-button
              v-if="!isPastYearMode"
              @click="lastMonthDate"
            >
              先月
            </vs-button>
            <vs-button
              v-if="isPastYearMode"
              @click="pastYearsDate"
            >
              過去一年
            </vs-button>
            <vs-button
              v-if="isPastYearMode"
              @click="pastTwoYearsDate"
            >
              過去二年
            </vs-button>
          </div>
        </div>
        <div class="w-4/5 bg-grid-color inline-flex items-center justify-end">
          <div>
            <Datepicker
              v-model="inputValue"
              :min-date="minDate"
              :max-date="maxDate"
              :max-range="maxRange"
              :enable-time-picker="false"
              :month-change-on-scroll="false"
              :range="true"
              week-start="0"
              locale="ja"
              multi-calendars
              inline
              year-first
              auto-apply
              no-today
              no-disabled-range
            >
              <template #year="{ value }">
                {{ value }}年
              </template>
            </Datepicker>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Datepicker from '@vuepic/vue-datepicker'
import moment from 'moment'

export default {
  name: 'DateRanges',
  components: {
    Datepicker
  },
  props: {
    startDay: {
      type: String,
      default: null
    },
    endDay: {
      type: String,
      default: null
    },
    isPastYearMode: {
      type: Boolean,
      default: false
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    },
    maxRange: {
      type: Number,
      default: null
    },
    onChange: {
      type: Function,
      default: () => {}
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    }
  },
  emits: [
    'update:start-day',
    'update:end-day',
    'onChange'
  ],
  data () {
    return {
      popupActive: false
    }
  },
  computed: {
    period: {
      get () {
        return `${this.dateSet(this.startDay)}-${this.dateSet(this.endDay)}`
      }
    },
    inputValue: {
      get () {
        if (this.startDay !== null && this.endDay !== null) {
          return [this.startDay, this.endDay]
        }
        return null
      },
      set (newValue) {
        this.$emit('update:start-day', (newValue === null) ? null : moment(newValue[0]).format(this.format))
        this.$emit('update:end-day', (newValue === null) ? null : moment(newValue[1]).format(this.format))
        this.$emit('onChange', (newValue === null) ? null : { start: moment(newValue[0]).toDate(), end: moment(newValue[1]).toDate() })
        this.popupActive = false
      }
    }
  },
  methods: {
    todayDate () {
      const start = moment().format()
      const end = moment().format()
      this.$emit('update:start-day', start)
      this.$emit('update:end-day', end)
      this.$emit('onChange', { start, end })
      this.popupActive = false
    },
    yesterdayDate () {
      const start = moment().subtract(1, 'days').format()
      const end = moment().subtract(1, 'days').format()
      this.$emit('update:start-day', start)
      this.$emit('update:end-day', end)
      this.$emit('onChange', { start, end })
      this.popupActive = false
    },
    thisMonthDate () {
      const start = moment().startOf('month').format()
      const end = moment().endOf('month').format()
      this.$emit('update:start-day', start)
      this.$emit('update:end-day', end)
      this.$emit('onChange', { start, end })
      this.popupActive = false
    },
    lastMonthDate () {
      const start = moment().subtract(1, 'months').startOf('month').format()
      const end = moment().subtract(1, 'months').endOf('month').format()
      this.$emit('update:start-day', start)
      this.$emit('update:end-day', end)
      this.$emit('onChange', { start, end })
      this.popupActive = false
    },
    pastYearsDate () {
      const start = moment().subtract(1, 'years').format()
      const end = moment().subtract(1, 'days').format()
      this.$emit('update:start-day', start)
      this.$emit('update:end-day', end)
      this.$emit('onChange', { start, end })
      this.popupActive = false
    },
    pastTwoYearsDate () {
      const start = moment().subtract(2, 'years').format()
      const end = moment().subtract(1, 'days').format()
      this.$emit('update:start-day', start)
      this.$emit('update:end-day', end)
      this.$emit('onChange', { start, end })
      this.popupActive = false
    },
    dateSet (day) {
      return moment(day).format('YYYY年MM月DD日')
    }
  }
}
</script>

<style scoped>
:root {
  --dp-cell-size: 33px;
}
</style>
